$(function() {
    function animateTeaserBackground(value) {
        if ($('div.wellness-page.christmas div.teaser').length > 0) {
            $('div.wellness-page.christmas div.teaser').animate({
                'background-position-x': value
            }, 10000, 'linear', function() {
                var currentValue = parseFloat($('div.teaser').css('background-position-x').replace('px', null), 10);
                if (currentValue < 0) animateTeaserBackground(0);
                if (currentValue >= 0) animateTeaserBackground(-40);
            });
        }
    }
    animateTeaserBackground(-40);

    function rotateCountdown(duration) {
        setTimeout(function () {
            if ($('div.wellness-page.christmas div.countdown > span:not(.active)').length > 0) {
                var active = $('div.wellness-page.christmas div.countdown > span.active');
                var notActive = $('div.wellness-page.christmas div.countdown > span:not(.active)');

                notActive.addClass('active');
                active.removeClass('active');
            }

            rotateCountdown(duration);
        }, duration);
    }
    rotateCountdown(3000);


    // Horizontal scrollflow
    $(window).resize(function() {
        adjustScrollflow();
    });
    adjustScrollflow();

    function adjustScrollflow() {
        if ($('div.wellness-page').length > 0) {
            $('div.horizontal-scrollflow').css('margin-left', $('div.container.main-container').offset().left + 15);

            $('div.booking-box-space').height($('div.wellness-page div.booking-box').height());
        }
    }
});
